export class WorkerManagerError extends Error {
  constructor(error) {
    super();
    this.message = error?.message || error || i18n.$t('We encountered an unexpected error.');
  }
}
